// --- Checkout button guard ---------------------------------------------------
// The cart's <button is="custom-button" name="checkout"> was submitting the cart
// form WITHOUT its own name/value, so Shopify received POST /cart with an empty
// body, read it as a plain cart update, and 302'd straight back to /cart —
// i.e. the button appeared to just reload the page.
//
// Injecting the parameter as a hidden input on click (capture phase, before any
// submit handling) guarantees Shopify sees a checkout request no matter how the
// form ends up being submitted. Deliberately does NOT preventDefault, so the
// theme's own submit flow, validation and loading state all still run.
(function () {
  document.addEventListener(
    "click",
    function (event) {
      var btn = event.target.closest('[name="checkout"]');
      if (!btn) return;
      var form = btn.form || btn.closest("form");
      if (!form) return;
      if (form.querySelector('input[type="hidden"][name="checkout"]')) return;
      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "checkout";
      hidden.value = "";
      form.appendChild(hidden);
    },
    true
  );
})();

// Upgrade-swap for the cart subscription upsell.
// Delegated click handler survives cart re-renders. Adds the subscription line
// FIRST, then removes the one-time line — so a failed request can never empty the cart.
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-wcu-upgrade]");
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute("aria-busy") === "true") return;

    var variantId = Number(btn.getAttribute("data-wcu-variant"));
    var planId = Number(btn.getAttribute("data-wcu-plan"));
    var removeKey = btn.getAttribute("data-wcu-remove-key");
    var context = btn.getAttribute("data-wcu-context") || "drawer";
    var headers = { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" };

    btn.setAttribute("aria-busy", "true");

    fetch(root + "cart/add.js", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ id: variantId, selling_plan: planId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return fetch(root + "cart/change.js", {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ id: removeKey, quantity: 0 })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("change failed");
        if (context === "page") {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      })
      .catch(function () {
        // Leave the cart intact; re-enable and refresh so the user sees current state.
        btn.removeAttribute("aria-busy");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      });
  });
})();
